import { Box, IconButton, styled } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

export const Wrapper = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1),
	padding: '0 16px 8px 16px',
	color: theme.palette.text.primary,
}));

export const CrumbButton = styled(IconButton)(({ theme, color }) => ({
	height: '32px',
	width: 'auto',
	minWidth: 'auto',
	padding: 0,
	color:
		color && color !== 'default' && color !== 'inherit' && color in theme.palette
			? theme.palette[color].main
			: theme.palette.text.primary,
	'& svg': {
		width: '18px',
		height: '18px',
	},
}));

export const CrumbLink = styled(MediaTypography)(({ theme }) => ({
	background: 'none',
	border: 0,
	padding: 0,
	cursor: 'pointer',
	color: theme.palette.primary.main,
	textAlign: 'left',
}));

export const Separator = styled('span')(({ theme }) => ({
	color: theme.palette.text.secondary,
	fontSize: '12px',
	lineHeight: 1,
	userSelect: 'none',
}));
